import { useState } from "react";
import { Header } from "../../../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../../../components/Landing/Header/headerScc";
import { Footer } from "../../../../../components/Landing/Footer";
import { Button, Modal, Radio } from "antd";
import ArtistasCallejeros from "../../../../../assets/artistaCallejero.jpg"
import FeriaFlores from "../../../../../assets/FeriaFlores.jpg"
import bannerArtistasCallejeros from "../../../../../assets/bannerArtistasCallejeros.jpg"
import bannerFeriaFlores from "../../../../../assets/bannerFeriaFlores.jpg"

// bandas de marcha
import bannerBandasMarcha from "../../../../../assets/Banner concurso de bandas_Mesa.png"
import lineamientoBandasMarcha from "../../../../../assets/Lineamientos 12º Concurso Internacional de Bandas Medellín Marcha Musical.pdf"
import cartaConformacion from "../../../../../assets/formato/Carta de conformacion de grupo.docx"
import ABCEstiloMilitar from "../../../../../assets/formato/ABC Estilo Militar Colombiano - español e ingles.pdf"
import aceptacionManual from "../../../../../assets/formato/Aceptación Manual ABC Estilo Militar Colombiano.docx"
import aceptacionLineamientos from "../../../../../assets/formato/Aceptación lineamientos 2026.docx"
import conceptoJuridico from "../../../../../assets/formato/Concepto jurídico ABC Estilo Militar Colombiano.pdf"
// bandas de marcha

import { FaInfoCircle, FaWpforms } from "react-icons/fa"
const bannerMuseos = process.env.PUBLIC_URL + encodeURI("/assets/bannerformulariomuseos.png");
import propuestaTecnicaMuseos from "../../../../../assets/formato/Formato-Propuesta-Invitacion-Museos-2025.docx"
import presupuestoMuseos from "../../../../../assets/formato/Formato-Presupuesto-Inivtacion-Museos-2025.xlsx"
import DeclaracionMuseos from "../../../../../assets/formato/Declaracion-juramentada-nivel-desempeÃ±o-museal-2025.docx"
import lineamientoMMM from "../../../../../assets/formato/Invitacion_Beneficios_Museos_Publicable.pdf"

//Feria
import propuestaTecnicaFeria from "../../../../../assets/formato/FormatoPropuestaTecnica_invitacionpublica.docx"
import presupuestoFeria from "../../../../../assets/formato/FormatoPresupuesto_invitacionpublica.xlsx"
import DeclaracionMuseosGrupos from "../../../../../assets/formato/DeclaraciondeResidenciaGruposConformados2025_invitacionpublica.docx"
import trayectoriaFeria from "../../../../../assets/formato/Formato_Trayectoria_invitacionpublica.docx"
import relacionFeria from "../../../../../assets/formato/RelaciondeParticipantes_invitacionpublica.docx"
import lineamientoFeria from "../../../../../assets/formato/Invitación_Desfile_de_Comparsas_Avenida_Primavera_y_Desfile_de_Silleteros.pdf"
import bannerEventos from "../../../../../assets/eventosCiudad.png"
//Feria

const BannerformularioRedC = process.env.PUBLIC_URL + encodeURI("/assets/Banner formulario RedC.jpg");
import RedCasas from "../../../../../assets/RedCasas.jpeg"
import resultadosRed from "../../../../../assets/Resultados_Invitación pública_Red de Casas de Cultura_20_08_2026.pdf"

import BannerConnsejoCultura from "../../../../../assets/Banner Consejo de Cultura.png"

const lineamientoBancoFormadores = process.env.PUBLIC_URL + encodeURI("/assets/Terminos de referencia - Convocatoria abierta conformacion banco de formadores elegibles - 2026.pdf");
import bannerObservacion from "../../../../../assets/observacion.jpeg"


const anexo = process.env.PUBLIC_URL + encodeURI("/assets/Anexo - Oferta de talleres priorizados por comuna componente de formación artística y cultural vigencia 2026.pdf");
const inscritosFormadores = process.env.PUBLIC_URL + encodeURI("/assets/Inscritos a la convocatoria del Banco de Formadores.pdf");
import feDeErrata from "../../../../../assets/FE DE ERRATAS.pdf"
import avisoPublicacion from "../../../../../assets/Aviso de publicación de habilitados y subsanaciones del Banco de Elegibles de Artistas Formadores 2026.pdf"
import resultados from "../../../../../assets/Resultados de la verificación de requisitos y listado de aspirantes habilitados de la convocatoria del Banco de Artistas Formadores 2026.pdf"

// Comite lep
import BannerComitelep from "../../../../../assets/comitelep.jpg"


interface Formato {
  nombre: string;
  url: string;
}

export const Form = () => {

  const [visualizarDocument, setVisualizarDocument] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');
  const [banner, setBanner] = useState<string>('');
  const [evento, setEvento] = useState<string>('');
  const [lineamiento, setLineamiento] = useState<string>('');
  const [formatos, setFormatos] = useState<Formato[]>([]);
  const [pj, setPj] = useState<Formato[]>([]);
  const [gC, setGC] = useState<Formato[]>([]);

  const abrirForm = (item) => {
    setUrl(item.url)
    setBanner(item.banner)
    setEvento(item.evento)
    setLineamiento(item.lineamiento)
    setFormatos(item.formatos)
    setPj(item.pj)
    setGC(item.gC)
    setVisualizarDocument(true);
  }

  const onCancel = () => {
    setVisualizarDocument(false);
    setUrl('')
  }

  const event = [
    {
      url: "https://ee.kobotoolbox.org/single/79076a6ad227c54e8c01633a4ab3be73",
      banner: BannerComitelep,
      boton: BannerComitelep,
      evento: "Comite LEP",
      gC: [],
      pj: []
    },
    {
      url: "https://ee.kobotoolbox.org/x/7ZXelne6",
      banner: BannerConnsejoCultura,
      boton: BannerConnsejoCultura,
      evento: "Consejo de Cultura",
      gC: [],
      pj: []
    },
    {
      url: "https://docs.google.com/forms/d/e/1FAIpQLScrCyWXpwzxlHrPTbfq0Vd6yOaJ4928Cq8ZiGJGFLcVEhVXng/viewform?embedded=true",
      banner: bannerBandasMarcha,
      boton: bannerBandasMarcha,
      evento: "11 Concurso Internacional de Bandas 2025",
      lineamiento: lineamientoBandasMarcha,
      formatos: [
        {
          nombre: "Carta de conformación",
          url: cartaConformacion
        },
        {
          nombre: "ABC Estilo Militar Colombiano - español e inglés",
          url: ABCEstiloMilitar
        },
        {
          nombre: "Aceptación Manual ABC Estilo Militar Colombiano",
          url: aceptacionManual
        },
        {
          nombre: "Aceptación lineamientos 2026",
          url: aceptacionLineamientos
        },
        {
          nombre: "Concepto jurídico ABC Estilo Militar Colombiano",
          url: conceptoJuridico
        }
      ],
      gC: [],
      pj: []
    },
    {
      url: "",
      banner: RedCasas,
      boton: BannerformularioRedC,
      evento: "RedC",
      gC: [],
      pj: [],
      formatos: [
        {
          nombre: "Resultados de la invitación pública Red de Casas de Cultura",
          url: resultadosRed
        }
      ]
    },
    {
      url: "https://docs.google.com/forms/d/e/1FAIpQLSdLvlSIqenKT9o8DdVRpgXpQg5JPqF6EM02BIrhnt7GNUpy2A/viewform?embedded=true",
      banner: bannerObservacion,
      boton: bannerObservacion,
      evento: "Observación",
      lineamiento: lineamientoBancoFormadores,
      formatos: [
        {
          nombre: "Oferta de talleres priorizados por comuna",
          url: anexo
        },
        {
          nombre: "Inscritos a la convocatoria del Banco de Formadores",
          url: inscritosFormadores
        },
        {
          nombre: "Fe de erratas",
          url: feDeErrata
        },
        {
          nombre: "Aviso de publicación de habilitados y subsanaciones del Banco de Elegibles de Artistas Formadores 2026",
          url: avisoPublicacion
        },
        {
          nombre: "Resultados de la verificación de requisitos y listado de aspirantes habilitados de la convocatoria del Banco de Artistas Formadores 2026",
          url: resultados
        }
      ],
      gC: [],
      pj: []
    },
    {
      url: "https://docs.google.com/forms/d/e/1FAIpQLSdSnKEefKESVCz927Iem0cqc5IaWQkq7bDPeysaV1ZFEs975A/viewform?embedded=true",
      banner: bannerEventos,
      boton: bannerEventos,
      evento: "Eventos de ciudad 2026",
      gC: [],
      pj: []
    },
    {
      url: "https://docs.google.com/forms/d/e/1FAIpQLSfTzX6RyGZrcmIMBhW8Lj1RG5BroTEAcCGQSpL4ukSkNP94IA/viewform?embedded=true",
      banner: bannerMuseos,
      boton: bannerMuseos,
      evento: "Invitación Museos 2025",
      lineamiento: lineamientoMMM,
      formatos: [
        {
          nombre: "Formato de propuesta técnica",
          url: propuestaTecnicaMuseos
        },
        {
          nombre: "Formato de presupuesto",
          url: presupuestoMuseos
        },
        {
          nombre: "Formato de declaración juramentada",
          url: DeclaracionMuseos
        }
      ],
      gC: [],
      pj: []
    },
    {
      url: '',
      gC: [
        {
          nombre: "Grupo Conformado",
          url: 'https://docs.google.com/forms/d/e/1FAIpQLSf8w4qbs7TxnXiImTCgbSCCEdMUJ2k85l1FDsPGip07NN3X5Q/viewform?embedded=true'
        }
      ],
      pj: [
        {
          nombre: "Persona Jurídica",
          url: 'https://docs.google.com/forms/d/e/1FAIpQLSe07xFvGAKH8LF7ic-K4w5Zihs8eUvkKJWafmcsyq3qyEheqA/viewform?embedded=true'
        },
      ],
      banner: bannerFeriaFlores,
      boton: FeriaFlores,
      evento: "Feria de las Flores 2025",
      lineamiento: lineamientoFeria,
      formatos: [
        {
          nombre: "Formato de propuesta técnica",
          url: propuestaTecnicaFeria
        },
        {
          nombre: "Formato de presupuesto",
          url: presupuestoFeria
        },
        {
          nombre: "Formato declaración de residencia grupos conformados",
          url: DeclaracionMuseosGrupos
        },
        {
          nombre: "Formato de trayectoria",
          url: trayectoriaFeria
        },
        {
          nombre: "Formato de relación de participantes",
          url: relacionFeria
        }
      ],
    },
    {
      url: "https://docs.google.com/forms/d/e/1FAIpQLScAh4SdH0L-qEoRI0Hsv3K3VH-OfpK9w_vxfmj4GThUAj8Ebg/viewform?embedded=true",
      banner: bannerArtistasCallejeros,
      boton: ArtistasCallejeros,
      evento: "Artistas Callejeros 2025",
      gC: [],
      pj: []
    }
  ];

  const [tipoFormulario, setTipoFormulario] = useState(null);

  const handleTipoChange = e => {
    setTipoFormulario(e.target.value);
  };


  return (
    <>
      <Header />
      <HeaderScc />
      <div className="">
        <div className="row">
          <br />
        </div>
        <div className="justify-content-center">
          <div className="container-titles-information-component">
            <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
              Formularios de{" "}<span className="font-family-Montserrat-Bold"> Inscripciones</span>
            </div>
          </div>
        </div>
        <div className="container-fluid2 pt-5">
          <div className="row justify-content-center">
            {event.map((item) => (
              <div className="col-md-6 col-sm-12" key={item.evento || item.url}>
                <br />
                <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                  <img
                    src={item.boton}
                    alt={`Evento ${item.evento}`}
                    className="card4"
                    style={{ cursor: "pointer" }}
                    onClick={() => abrirForm(item)}

                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') (e.currentTarget as HTMLElement).click(); }}
                  />
                </div>
                <br />
              </div>
            ))}
          </div>
        </div>
        <div className="row">
          <br />
          <br />
        </div>
      </div>
      <Modal
        className="ant-modal-close-x2"
        maskStyle={{
          backgroundColor: "rgba(6, 100, 144 ,0.71)",
        }}
        visible={visualizarDocument}
        onCancel={onCancel}
        width={1200}
        footer={[
          <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
            Cerrar
          </Button>,
        ]}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div>
          <img
            src={banner}
            alt={`Evento ${evento}`}
            className="card4"
            style={{ cursor: "pointer" }}
          />
          <br />
          <br />
          {lineamiento ? (
            <div className="font-size-26px font-family-Montserrat text-center font-color-black">
              <a target="_blank" href={lineamiento}><FaInfoCircle /> Lineamiento y condiciones de participación</a>
              <br />
            </div>
          ) : ''
          }
          {
            <div>
              {formatos?.length > 0 && formatos.map((formato) => (
                <div
                  key={formato.nombre}
                  className="font-size-26px font-family-Montserrat text-center font-color-black"
                >
                  <a className="font-color-black" target="_blank" href={formato.url} rel="noopener noreferrer">
                    <FaWpforms /> {formato.nombre}
                  </a>
                  <br />
                </div>
              ))}
            </div>
          }
          <br />
          {url ? (
            <iframe
              src={url}
              title="Formulario"
              style={{ width: '100%', height: '500px' }}
            />
          ) : (
            ''
          )}
          {
            <div className="container">
              {evento === 'Feria de las Flores 2025' && (
                <div>
                  <div className="font-size-16px font-family-Montserrat text-center font-color-black">
                    Por favor, elija un formulario de registro.
                  </div>
                  <div className="text-center my-4">
                    <Radio.Group onChange={handleTipoChange} value={tipoFormulario}>
                      <Radio value="GC">
                        <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                          Grupo Conformado (GC)
                        </div>
                      </Radio>
                      <Radio value="PJ">
                        <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                          Persona Jurídica (PJ)
                        </div>
                      </Radio>
                    </Radio.Group>
                  </div>
                </div>
              )}
              <div className="row">
                {tipoFormulario === 'GC' && (
                  <div className="col-12 text-center">
                    {gC.map((item) => (
                      <div key={item.nombre || item.url} className="mb-4">
                        <iframe
                          src={item.url}
                          title={`Formulario GC ${item.nombre}`}
                          style={{ width: '100%', height: '500px' }}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {tipoFormulario === 'PJ' && (
                  <div className="col-12 text-center">
                    {pj.map((item) => (
                      <div key={item.nombre || item.url} className="mb-4">
                        <iframe
                          src={item.url}
                          title={`Formulario PJ ${item.nombre}`}
                          style={{ width: '100%', height: '500px' }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          }
        </div>
      </Modal>
      <Footer />
    </>
  );
};
